import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import api from '../middleware/api';
import tinabalikeApp from '../reducers';

const configureStore = preloadedState => createStore(
  tinabalikeApp,
  preloadedState,
  applyMiddleware(thunk, api)
);

export default configureStore;



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.prod.js
 **/